function configuredUrl(value: string, origin: string) {
  const url = new URL(value, origin);
  const page = new URL(origin);
  // A physical test phone must reach the Mac serving the development WebView.
  if (process.env.NODE_ENV !== "production" && page.protocol === "http:"
    && ["localhost", "127.0.0.1", "[::1]"].includes(url.hostname)) {
    url.hostname = page.hostname;
  }
  return url;
}

const trailingSlash = (value: string) => value.replace(/\/+$/, "") + "/";

export function apiBaseUrl(
  configured = process.env.REACT_APP_API_URL,
  origin = window.location.origin,
) {
  if (configured) return trailingSlash(configuredUrl(configured, origin).href);
  const local = ["localhost", "127.0.0.1"].includes(new URL(origin).hostname);
  return local ? `${new URL(origin).protocol}//${new URL(origin).hostname}:3030/` : `${origin}/F_shopping/back/`;
}

export function socketServerUrl(apiUrl: string, configured = process.env.REACT_APP_SOCKET_URL, origin = window.location.origin) {
  return configured
    ? configuredUrl(configured, origin).href.replace(/\/+$/, "")
    : `${new URL(apiUrl).origin}/live`;
}
